import {
  createSerializationOptionsForEnumValue,
  useSearchParamState,
} from 'utils/hooks/useSearchParamState';
import { MessageMediumTabs } from 'modules/intelligentInsights/frequencyOptimization/types';

export const useFroInsightsSearchParams = () => {
  const [selectedTab, setSelectedTab] = useSearchParamState({
    searchParamKey: 'tab',
    stateValueWhenSearchParamIsUnset: MessageMediumTabs.Email,
    ...createSerializationOptionsForEnumValue({
      enumKeyValueMap: MessageMediumTabs,
      stateValueWhenSearchParamIsInvalid: MessageMediumTabs.Email,
    }),
  });

  return {
    selectedTab,
    setSelectedTab,
  };
};
